import qs from 'qs'
import _ from 'lodash'

import http from '../utils/http'
import config from '../config'
import Converter from '../utils/converter'
import * as storage from '../utils/storage'

class PageModel {
  static baseUrl = config.baseUrl + '/page'
  static judge = '/qigong/judge'
  static goods = config.baseUrl + '/goods'
  static uploadUrl = config.baseUrl + '/upload/mp'
  static tool = '/tool'
  static diff = '/difficulty'

  static async getPageInfo(pageId) {
    let { payload: pageInfo, pageId: pId, pageProperty } = await http.get(
      `${PageModel.baseUrl}/get/${pageId}`
    )
    // console.log(pageInfo)
    // V1版数据转换
    pageInfo = Converter.convertPageInfoFromV1(pageInfo)

    PageModel._storageDatas(pageInfo)
    pageInfo.pId = pId
    let obj = { pageInfo, pageProperty }
    return obj
  }

  // 初始化storage存储数据，避免首次没缓存导致未修改数据也发送给服务器
  static _storageDatas(pageInfo) {
    const pageId = pageInfo.pageId
    const containers = pageInfo.containers
    _.forEach(containers, container => {
      const containerId = container.containerId
      const type = container.type
      if (type === 1) {
        const cols = container.cols
        const rows = container.rows

        _.forEach(rows, row => {
          const rowId = row.rowId
          _.forEach(cols, col => {
            const colId = col.colId

            const key = `${pageId}_${containerId}_${rowId}_${colId}`
            const data = row[colId].value

            storage.setItem(key, data)
          })
        })
      } else if (type === 2) {
        const items = container.items
        _.forEach(items, item => {
          const id = item.id

          const key = `${pageId}_${containerId}_-1_${id}`
          const data = item.value

          storage.setItem(key, data)
        })
      }
    })
  }

  static async saveData({ pageId, containerId, rowId, colId, data }) {
    const key = `${pageId}_${containerId}_${rowId}_${colId}`
    const storageData = storage.getItem(key)
    // 通过本地存储每个发送值，如果前一次值跟本次相等，不执行发送操作
    if (storageData === data) {
      return null
    }

    const { payload: res } = await http.post(
      `${PageModel.baseUrl}/save`,
      qs.stringify({ pageId, containerId, rowId, colId, value: data }),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    storage.setItem(key, data)
    return res
  }

  static async createALine({ pageId, containerId }) {
    const { payload: res } = await http.post(
      `${PageModel.baseUrl}/table/addLine/${pageId}/${containerId}`
    )
    return res
  }

  static async deleteLines({ pageId, containerId, rowIds }) {
    const res = await http.delete(
      `${PageModel.baseUrl}/table/deleteLines/${pageId}/${containerId}/${rowIds}`
    )
    return res
  }

  static async copyALine({ pageId, containerId, sourceRowId }) {
    const { payload: res } = await http.put(
      `${PageModel.baseUrl}/table/copyLines/${pageId}/${containerId}/${sourceRowId}`
    )
    return res
  }

  static async uploadImg(action, formdata) {
    const { payload: res } = await http.post(action, formdata)
    return res
  }

  static async deleteImage({ pageId, containerId, rowId, colId, imageId }) {
    const { payload: res } = await http.delete(
      `${PageModel.baseUrl}/image/delete/${pageId}/${containerId}/${rowId}/${colId}/${imageId}`
    )
    return res
  }

  static async deleteMusic({ pageId, containerId, rowId, colId, musicId }) {
    const { payload: res } = await http.delete(
      `${PageModel.baseUrl}/music/delete/${pageId}/${containerId}/${rowId}/${colId}/${musicId}`
    )
    return res
  }

  static async deleteVideo({ pageId, containerId, rowId, colId, videoId }) {
    const { payload: res } = await http.delete(
      `${PageModel.baseUrl}/music/delete/${pageId}/${containerId}/${rowId}/${colId}/${videoId}`
    )
    return res
  }

    static async deleteFile({ pageId, containerId, rowId, colId, fileId }) {
    const { payload: res } = await http.delete(
      `${PageModel.baseUrl}/music/delete/${pageId}/${containerId}/${rowId}/${colId}/${fileId}`
    )
    return res
  }

  static async submit() {
    const { payload: res } = await http.post(`${PageModel.baseUrl}/submit`)
    return res
  }

  static async getPrintContent() {
    const { payload: res } = await http.get(`${PageModel.baseUrl}/print`)
    return res
  }

  static async getPayContent() {
    const { payload: res } = await http.get(`${PageModel.baseUrl}/pay`)
    return res
  }

  static async getpaystatue(tradeNo) {
    const data = await http.get(`${config.baseUrl}/paystatue/${tradeNo}`)
    return data
  }


  static async cancelpay(tradeNo) {
    const data = await http.post(`${PageModel.baseUrl}/cancelpay/${tradeNo}`)
    return data
  }

  static async buttonSubmit(gameId, teamId, pId, rowId) {
    const data = await http.post(`${PageModel.judge}/grade/addApply`, { allgames_gameID: parseInt(gameId), teams_id: parseInt(teamId), pages_id: pId, rowId })
    return data
  }

  static async createTeam(teamName, groupEvent, isCreatorMember) {
    const data = await http.post(`${config.baseUrl}/groupevent/create/${teamName}/${groupEvent}/${isCreatorMember}`)
    return data
  }

  static async getTeamInfo(groupEventId) {
    const data = await http.get(`${config.baseUrl}/groupevent/url/${groupEventId}`)
    return data
  }

  //获取商品列表
  static async getGoodsList(tag, colId, rowId) {
    const data = await http.get(`${PageModel.goods}/list/${tag}/${colId}/${rowId}`)
    return data.payload
  }

  //预订商品
  static async orderGoods(xOldOrderId, xGoodsId,  athlete, qty, colId, rowId) {
    const data = await http.post(`${PageModel.goods}/order/${xOldOrderId}/${xGoodsId}/${athlete}/${qty}/${colId}/${rowId}`)
    return data
  }


  static async deduction(oldGoods, goods) {
    const data = await http.post(`${PageModel.goods}/deduction?oldGoods=${oldGoods}&goods=${goods}`)
    return data
  }

  //申报难度
  static async gettoken(colId, rowId) {
    const data = await http.get(`${config.baseUrl}/actions/gettoken/${colId}/${rowId}`)
    return data
  }

  //身份证查重
  static async IDCheck(gameId, teamId, idCardOld, idCardNew) {
    const data = await http.post(`${PageModel.tool}/idCard`, { gameId: parseInt(gameId), teamId: parseInt(teamId), idCardOld, idCardNew })
    return data
  }

  //获得难度动作申报资料
  static async getDifficulty(obj) {
    const data = await http.post(`${PageModel.diff}/difficulty_action/get_information`, obj)
    return data
  }


  //递交难度动作申报资料
  static async uploadDifficulty(obj) {
    const data = await http.post(`${PageModel.diff}/difficulty_action/upload_information`, obj)
    return data
  }

  //获得必选动作申报资料
  static async getRequired(obj) {
    const data = await http.post(`${PageModel.diff}/required_action/get_information`, obj)
    return data
  }

    //递交必选动作申报资料
    static async uploadRequired(obj) {
      const data = await http.post(`${PageModel.diff}/required_action/upload_information`, obj)
      return data
    }

    //上传obs初始化
    static async uploadInit( obj) {
      const data = await http.post(`${PageModel.uploadUrl}/init`, obj)
      return data
    }
    //上传obs单段签名
    static async uploadSign(objectKey,uploadId,partNo) {
      const data = await http.get(`${PageModel.uploadUrl}/sign/${objectKey}/${uploadId}/${partNo}`)
      return data
    }
    //上传obs合并
    static async uploadComplete(url,obj) {
      const data = await http.post(url, obj)
      return data
    }
    
    //取消obs上传
    static async cancelUpload(obj) {
      const data = await http.post(`${PageModel.uploadUrl}/abort`, obj)
      return data
    }

}

export default PageModel
